var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarStatusOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0191 9.95297L20.4805 8.63578L19.5256 6.3C18.7057 4.29516 16.7502 3 14.5427 3H8.45729C6.25025 3 4.29429 4.29516 3.47444 6.3L2.51946 8.63578L1.98088 9.95297C0.825125 10.3828 0 11.4684 0 12.75V15C0 15.7556 0.295167 16.4377 0.766667 16.9655V19.5C0.766667 20.3283 1.45331 21 2.3 21H3.83333C4.68002 21 5.36667 20.3283 5.36667 19.5V18H17.6333V19.5C17.6333 20.3283 18.32 21 19.1667 21H20.7C21.5467 21 22.2333 20.3283 22.2333 19.5V16.9655C22.7048 16.4381 23 15.7561 23 15V12.75C23 11.4684 22.1749 10.3828 21.0191 9.95297ZM6.32165 7.41422C6.67096 6.56016 7.51669 6 8.45729 6H14.5427C15.4833 6 16.329 6.56016 16.6784 7.41422L17.6333 9.75H5.36667L6.32165 7.41422ZM3.83333 14.9906C2.91333 14.9906 2.3 14.3925 2.3 13.4953C2.3 12.5981 2.91333 12 3.83333 12C4.75333 12 6.13333 13.3458 6.13333 14.243C6.13333 15.1402 4.75333 14.9906 3.83333 14.9906ZM19.1667 14.9906C18.2467 14.9906 16.8667 15.1402 16.8667 14.243C16.8667 13.3458 18.2467 12 19.1667 12C20.0867 12 20.7 12.5981 20.7 13.4953C20.7 14.3925 20.0867 14.9906 19.1667 14.9906Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarStatusOff);
export default __webpack_public_path__ + "static/media/carStatusOff.a6c11235a7f145f668e382fb11036e38.svg";
export { ForwardRef as ReactComponent };